import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MortgageBrokerage } from '@models/brokerage';
import { Company } from '@models/company';
import { MatterMortgageDispatch } from '@state/matter/matter_mortgages';

export interface MortgageBrokerageModalData {
	brokerage: MortgageBrokerage;
	matterMortgageId: string;
	searchTerm?: string;
}

@Component({
	selector: 'app-mortgage-brokerage-modal',
	templateUrl: './mortgage-brokerage-modal.component.html',
	standalone: false,
})
export class MortgageBrokerageModalComponent {
	public name: string;
	public brokerage: Company;
	public matterMortgageId: string;

	constructor(
		private matterMortgageDispatch: MatterMortgageDispatch,
		public dialogRef: MatDialogRef<MortgageBrokerageModalComponent>,
		@Inject(MAT_DIALOG_DATA) public data: MortgageBrokerageModalData,
	) {
		this.brokerage = data.brokerage ?? null;
		this.name = data.searchTerm ?? null;
		if (this.brokerage) {
			this.name = this.brokerage.name;
		}
		this.matterMortgageId = data?.matterMortgageId ?? null;
	}

	onSubmit(company: MortgageBrokerage) {
		this.matterMortgageDispatch.CreateMortgageBrokerage(
			this.matterMortgageId,
			company,
		);
		this.dialogRef.close();
	}

	onCancel() {
		this.dialogRef.close();
	}
}
